import Vue from "vue";
import { Ability, AbilityBuilder } from '@casl/ability'
import router from '../../router';
import { abilitiesPlugin } from "@casl/vue"

export const ability = new Ability();

export function defineAbilitiesFor(roles) {
  const {can, rules} = new AbilityBuilder(Ability);
  const allRoutes = getAllRoutes(router.options.routes);
  allRoutes.forEach((route) => {
    if (route.roles) {
      if (route.roles.some(r => roles.includes(r))) {
        can('manage', route.name);
      }
    }
  });
  roles.map(role => {
    can('manage', role);
  })
  ability.update(rules);
}

function getAllRoutes(routes) {
  const leafRoutes = [];

  function traverse(routeList) {
    for (const route of routeList) {
      if (route.children && route.children.length > 0) {
        traverse(route.children);
      } else {
        leafRoutes.push(route);
      }
    }
  }

  traverse(routes);
  return leafRoutes;
}


Vue.use(abilitiesPlugin, ability);

